<script setup lang="ts">
defineProps<{
  units: gen.SellerSizeGuideFragment['units'] | None
}>()

const holder = defineModel<string | undefined>({ required: true })
</script>

<template>
  <div v-if="(units?.length || 0) > 1" class="_row _spaced _pb1 _pl04 _pr04 _pt1 _ctrY">
    <div class="_row _ctrY _gap02">
      <button
        v-for="item in units"
        :key="item.key"
        type="button"
        :class="[$style.unit, item.key === holder && 'on']"
        @click="holder = item.key"
      >{{ item.unit }}</button>
    </div>
  </div>
</template>

<style module>
.unit {
  composes: global(_h34);
  composes: global(_pl2);
  composes: global(_pr2);
  composes: global(_fs09);
  composes: global(_fw-xl);
  composes: global(_ls-xs);
  composes: global(_br6);
  composes: global(_b5);
  composes: global(_bg0);
}
.unit:hover {
  border-color: var(--blue3);
  background: var(--blue5);
  color: var(--blue3);
}
.unit:global(.on) {
  background: var(--blue3);
  border-color: var(--blue3);
  color: var(--bg);
}
</style>
